const getOptions = (after, options, before = "") => {
  return options.map((label) => {
    const parameter = [before, label, after].filter((val) => val).join(" ");

    return { label, value: parameter };
  });
};

export const getIconOptions = (t) => {
  return [
    { label: t("icons"), value: false },
    { label: t("emojis"), value: true },
  ];
};

export const getToneOptions = (t) => {
  const toneKeys = [
    "confident",
    "emotional",
    "formal",
    "friendly",
    "humorous",
    "informal",
    "optimistic",
    "serious",
    "sympathetic",
    "warm",
  ];

  return getOptions("tone", toneKeys.map((key) => t(`tones.${key}`)));
};

export const LANGUAGE_OPTIONS = getOptions("language", [
  "Albanian",
  "Arabic",
  "Armenian",
  "Azerbaijani",
  "Belarusian",
  "Bosnian",
  "Bulgarian",
  "Catalan",
  "Chinese",
  "Croatian",
  "Czech",
  "Danish",
  "Dutch",
  "English",
  "Estonian",
  "Finnish",
  "French",
  "Georgian",
  "German",
  "Greek",
  "Hindi",
  "Hungarian",
  "Icelandic",
  "Irish",
  "Italian",
  "Japanese",
  "Kazakh",
  "Korean",
  "Latin",
  "Latvian",
  "Lithuanian",
  "Luxembourgish",
  "Macedonian",
  "Maltese",
  "Montenegrin",
  "Norwegian",
  "Polish",
  "Portuguese",
  "Romanian",
  "Romansh",
  "Russian",
  "Serbian",
  "Slovak",
  "Slovenian",
  "Spanish",
  "Swedish",
  "Turkish",
  "Ukrainian",
]);
